/** The Preferences section ids alone, free of icons, so address parsing can validate a slug without loading the UI. */
export const PREFERENCE_SECTION_IDS = [
  'availability',
  'notifications',
  'priority-contacts',
  'navigation',
  'appearance',
  'messages',
  'region',
  'accessibility',
  'mark-as-read',
  'privacy',
  'advanced',
] as const;

export type PreferenceSectionId = typeof PREFERENCE_SECTION_IDS[number];

export function isPreferenceSectionId(value: string | null | undefined): value is PreferenceSectionId {
  return !!value && (PREFERENCE_SECTION_IDS as readonly string[]).includes(value);
}

/** SF Symbols for each section, here rather than beside the web icons so the native app can read them without the icon set. */
export const PREFERENCE_SECTION_SYMBOLS: Readonly<Record<Exclude<PreferenceSectionId, 'mark-as-read'>, string>> = {
  availability: 'clock.fill',
  notifications: 'bell.fill',
  'priority-contacts': 'star.fill',
  navigation: 'sidebar.left',
  appearance: 'paintpalette.fill',
  messages: 'message.fill',
  region: 'globe',
  accessibility: 'accessibility',
  privacy: 'hand.raised.fill',
  advanced: 'gearshape.2.fill',
};
